/* ==========================================
   ABS ENGINEERING
   PRODUCTS SIDEBAR MEGA MENU
   ========================================== */

(function () {
  'use strict';

  function initialiseMegaMenu(menu) {
    if (menu.dataset.absInitialised === 'true') return;

    menu.dataset.absInitialised = 'true';

    var buttons = menu.querySelectorAll(
      '.abs-products-category'
    );

    var panels = menu.querySelectorAll(
      '.abs-products-panel'
    );

    buttons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var selectedPanel = button.getAttribute(
          'data-abs-panel'
        );

        // Update the selected category
        buttons.forEach(function (item) {
          var active = item === button;

          item.classList.toggle('is-active', active);
          item.setAttribute(
            'aria-expanded',
            String(active)
          );
        });

        // Display the matching content panel
        panels.forEach(function (panel) {
          panel.hidden = panel.id !== selectedPanel;
        });
      });
    });
  }

  function initialise() {
    document.querySelectorAll(
      '.abs-products-megamenu'
    ).forEach(initialiseMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();